const isProduction = process.env.NODE_ENV === 'production';

// In production the console noise is disabled: info/trace/debug/log/warn and the
// performance timing output are suppressed, while error remains
// available for real problems.
const noop = () => {};

const log = {
  error: console.error,
  warn: isProduction ? noop : console.warn,
  info: isProduction ? noop : console.log,
  log: isProduction ? noop : console.log,
  trace: isProduction ? noop : console.trace,
  debug: isProduction ? noop : console.debug,
  time: isProduction
    ? noop
    : key => {
        log.timingKeys[key] = true;
        console.time(key);
      },
  timeEnd: isProduction
    ? noop
    : key => {
        if (!log.timingKeys[key]) {
          return;
        }
        log.timingKeys[key] = false;
        console.timeEnd(key);
      },
  // Store the timing keys to allow knowing whether or not to log events
  timingKeys: {
    // script time values are added during the index.html initial load,
    // before log (this file) is loaded, and the log
    // can't depend on the enums, so for this case recreate the string.
    // See TimingEnum for details
    scriptToView: true,
  },
};

export default log;
